export { CallWebViewAdaptive as default } from "../../../navigation/ResponsiveScreens";
